import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

export const useCompaniesState = () =>
  useSelector((rootState: RootState) => rootState.companies);
